import useSupportQuestions from "../hooks/useSupportQuestions.ts";
import * as PageStyles from "./SupportPage.styles.ts";
import * as Styles from "./SupportQuestionsPage.styles.ts";
import ErrorBanner from "../../../components/Common/ErrorBanner/ErrorBanner.tsx";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const SupportQuestionPage = () => {
	const { questions, isLoading, isError } = useSupportQuestions();

	return (
		<PageStyles.Page data-testid="support-questions-page">
			<PageStyles.Header>
				<PageStyles.Title>Support Request</PageStyles.Title>
			</PageStyles.Header>

			<PageStyles.Content>
				<Styles.Heading id="support-questions-heading">I have questions.</Styles.Heading>

				<Styles.Panel
					aria-labelledby="support-questions-heading"
					aria-busy={isLoading}
				>
					{isLoading &&
						Array.from({ length: 8 }, (_, index) => (
							<Styles.LoadingRow
								key={index}
								variant="rectangular"
							/>
						))}

					{!isLoading && isError && (
						<ErrorBanner errorMessaging="Unable to load support questions. Please try again later." />
					)}

					{!isLoading &&
						!isError &&
						(questions.length === 0 ? (
							<PageStyles.EmptyMessage>
								No support questions are currently available.
							</PageStyles.EmptyMessage>
						) : (
							questions.map(({ id, title, answerHtml }) => (
								<Styles.Question
									key={id}
									disableGutters
									square
								>
									<Styles.Summary
										id={`${id}-heading`}
										aria-controls={`${id}-content`}
										expandIcon={<ExpandMoreIcon fontSize="small" />}
									>
										{title}
									</Styles.Summary>

									<Styles.Answer dangerouslySetInnerHTML={{ __html: answerHtml }} />
								</Styles.Question>
							))
						))}
				</Styles.Panel>
			</PageStyles.Content>
		</PageStyles.Page>
	);
};

export default SupportQuestionPage;
